import { Fragment, ReactElement } from 'react';
import ResearchDeathNonResidentNotificationCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-death-non-resident';

const ResearchDeathNonResidentNotificationCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchDeathNonResidentNotificationCivilStatusShared />
    </Fragment>
  );
};

ResearchDeathNonResidentNotificationCivilStatusPage.displayName =
  'Research Death Non Resident Notifications Page component';

export default ResearchDeathNonResidentNotificationCivilStatusPage;
